import { usePage } from '@inertiajs/react';

import { InertiaSharedProps } from '@/types';

/**
 * Whether a feature flag is active for the authenticated user, as resolved by
 * the backend (user > role > firm > global > default). Unknown keys are false,
 * so a stale reference fails closed. See .claude/skills/feature-flags for the
 * flag lifecycle.
 */
export const useFeature = (key: string): boolean => {
  const { features } = usePage<InertiaSharedProps<object>>().props;

  return features?.[key] ?? false;
};
